/* Affiliate landing: preserve ad attribution through Shopify sign-in.
 * CTA clicks are interest signals, never completed enrollments or purchases.
 */
(() => {
  'use strict';
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'aff', 'ref'];
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    let destination;
    try {
      destination = new URL(root.dataset.applyUrl, window.location.origin);
      if (destination.protocol !== 'https:' ||
          (destination.origin !== window.location.origin && destination.hostname !== 'shopify.com')) return;
    } catch (_) { return; }
    const source = new URLSearchParams(window.location.search);
    for (const key of keys) {
      const value = source.get(key);
      if (value) destination.searchParams.set(key, value.slice(0, 500));
    }
    const externalAccount = destination.origin !== window.location.origin;
    const target = externalAccount ? destination.href : destination.pathname + destination.search + destination.hash;
    const href = externalAccount || root.dataset.customer === 'true'
      ? target
      : '/customer_authentication/login?return_to=' + encodeURIComponent(target);
    root.querySelectorAll('[data-affiliate-apply]').forEach(link => {
      link.href = href;
      link.addEventListener('click', () => {
        try {
          const result = window.Shopify?.analytics?.publish('affiliate_apply_clicked', {
            placement: link.dataset.placement || 'landing',
            destination: destination.pathname
          });
          if (result?.catch) result.catch(() => {});
        } catch (_) { /* Analytics must not interrupt signup navigation. */ }
      });
    });
    const tracking = root.querySelector('#track');
    if (!tracking) root.querySelector('a[href="#track"]')?.remove();
  }
  init(document.querySelector('[data-affiliate-landing]'));
  document.addEventListener('shopify:section:load', event => {
    init(event.target.querySelector('[data-affiliate-landing]'));
  });
})();
